import { createApp, h } from 'vue';
import '@/js/lib/plugins/vee-validate';
import '@/js/lib/plugins/zod';
import common from '@/js/lib/common';
import { lazyCreateApp } from '@/js/lib/helper/lazy-mount';
import { applySmoothScroll } from '@/js/lib/helper/smooth-scroll';
import { startupTopics } from '@/js/lib/helper/startup-topics';
import { syncMemberIdToYappli } from '@/js/lib/helper/yappli';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import CampaignBanner from '@/js/components/campaign/HeaderBanner.vue';
import AppBanner from '@/js/components/common/AppBanner.vue';
import BrowsingHistory from '@/js/components/common/BrowsingHistory.vue';
import IHeader from '@/js/components/common/IHeader.vue';
import AppDownloadBanner from '@/js/components/organisms/AppDownloadBanner.vue';
import BasicDialog from '@/js/components/organisms/BasicDialog.vue';

common.initialize(common.env.Pallet);

startupTopics(common.env.Pallet.Topics);

applySmoothScroll();

// アプリDLバナー
const appDownloadBannerEl = document.querySelector('app-download-banner') as HTMLElement;
if (appDownloadBannerEl) {
  createApp(AppDownloadBanner).mount(appDownloadBannerEl);
}

const headerEl = document.querySelector('i-header') as HTMLElement;
createApp({
  render: () =>
    h(IHeader, {
      initialQuery: headerEl.dataset.initialQuery,
      useH1: headerEl.dataset.useH1 === 'true',
      isAccount: headerEl.dataset.isAccount === 'true',
      isSimple: headerEl.dataset.isSimple === 'true',
      apiKey: headerEl.dataset.apiKey!,
    }),
}).mount(headerEl);

// キャンペーンバナー
const campainBannerEl = document.querySelector('campaign-banner') as HTMLElement;
if (campainBannerEl) {
  createApp({
    render: () =>
      h(CampaignBanner, {
        title: campainBannerEl.dataset.title!,
        subtitle: campainBannerEl.dataset.subtitle!,
        color: campainBannerEl.dataset.color!,
        backgroundColor: campainBannerEl.dataset.backgroundColor!,
        href: campainBannerEl.dataset.href!,
        isSale: campainBannerEl.dataset.isSale === 'true',
      }),
  }).mount(campainBannerEl);
}

if (document.querySelector('browsing-history')) {
  lazyCreateApp(BrowsingHistory, 'browsing-history');
}

if (document.querySelector('app-banner')) {
  lazyCreateApp(AppBanner, 'app-banner');
}

// document上へのDrag&Dropを無視する
document.addEventListener('drop', (e) => {
  e.preventDefault();
});
document.addEventListener('dragover', (e) => {
  e.preventDefault();
});

// テキストエリアの高さを自動で広げる
document.querySelectorAll('textarea').forEach((el) => {
  el.addEventListener('keyup', (event) => {
    if ((event.target as HTMLTextAreaElement).scrollTop > 0) {
      el.rows += 1;
    }
  });
});

// aタグのhrefに合わせてログイン/会員登録DLGを表示
const signinSignupSet = (active: string) => {
  const signinSignupLinkEls: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(`a.js-${active}`);
  signinSignupLinkEls.forEach((el) => {
    const next = el.dataset.next;

    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (next) {
        signinSignup({
          active,
          next,
          callback: () => {
            window.location.href = next;
          },
        });
      } else {
        signinSignup({
          active,
          callback: () => {
            window.location.reload();
          },
        });
      }
    });
  });
};

signinSignupSet('signin');
signinSignupSet('signup');

const dialogEls: NodeListOf<HTMLElement> = document.querySelectorAll('basic-dialog');
if (dialogEls.length > 0) {
  dialogEls.forEach((el) => {
    const [linkText, dialogText] = [...el.querySelectorAll('template')];
    const linkHtml = linkText.innerHTML;
    const dialogHtml = dialogText.innerHTML;
    createApp({
      render: () =>
        h(
          BasicDialog,
          {
            hasUnderline: el.dataset.hasUnderline === 'true',
          },
          {
            link: () => h('div', { innerHTML: linkHtml }),
            dialog: () => h('div', { innerHTML: dialogHtml }),
          },
        ),
    }).mount(el);
  });
}

window.addEventListener('load', () => {
  if (window.Yappli && common.env.Pallet.Member?.member_id) {
    const memberIdOnYappli = `${common.env.Pallet.iichiEnv === 'prod' ? 'production' : 'staging'}-${common.env.Pallet.Member.member_id}`;
    if (common.env.Pallet.Yappli) {
      syncMemberIdToYappli(memberIdOnYappli, common.env.Pallet.Yappli.token);
    }
  }
});
